// extracted by mini-css-extract-plugin
export default {"landingContainer":"Landing_landingContainer__5n1eg","reservationContainer":"Landing_reservationContainer__P6Jd1","landingOuterContainer":"Landing_landingOuterContainer__unF0W"};